<template>
  <tab-item-template>
    <el-table border :data="processProfileView">
      <el-table-column
          label="名称"
          width="250"
          prop="name"
          sortable>
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="row.name"
                :value-local-id="row.processImplementation.localId">
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>
      <el-table-column
          label="説明"
          prop="description">
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="row.description"
                placeholder="未設定"
                multi-line>
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <!-- 生成 -->
      <el-table-column
          :label="processOperationOperationTypes['create']"
          prop="create"
          align="center"
          width="70"
          :resizable="false">
        <template #default="{row}">
          <table-inline>
            <readonly-checkbox :value="row.create && isProduceServiceType"></readonly-checkbox>
          </table-inline>
        </template>
      </el-table-column>

      <!-- 利用 -->
      <el-table-column
          :label="processOperationOperationTypes['read']"
          prop="read"
          align="center"
          width="70"
          :resizable="false">
        <template #default="{row}">
          <table-inline>
            <readonly-checkbox :value="row.read && isConsumeServiceType"></readonly-checkbox>
          </table-inline>
        </template>
      </el-table-column>

      <!-- 更新 -->
      <el-table-column
          :label="processOperationOperationTypes['update']"
          prop="update"
          align="center"
          width="70"
          :resizable="false">
        <template #default="{row}">
          <table-inline>
            <readonly-checkbox :value="row.update && isConsumeServiceType"></readonly-checkbox>
          </table-inline>
        </template>
      </el-table-column>

      <!-- 削除 -->
      <el-table-column
          :label="processOperationOperationTypes['delete']"
          prop="delete"
          align="center"
          width="70"
          :resizable="false">
        <template #default="{row}">
          <table-inline>
            <readonly-checkbox :value="row.delete && isConsumeServiceType"></readonly-checkbox>
          </table-inline>
        </template>
      </el-table-column>
    </el-table>
  </tab-item-template>
</template>

<script>
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import {mapActions, mapGetters, mapState} from "vuex";
import TableInline from "@/components/atoms/TableInline.vue";
import ReadonlyCheckbox from "@/components/atoms/ReadonlyCheckbox.vue";
import gql from "graphql-tag";
import uniq from "lodash/uniq";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import {PROCESS_OPERATION_OPERATION_TYPES} from "@/constants";

export default {
  name: "ProcessProfileTab",
  components: {TextFieldLike, ReadonlyCheckbox, TableInline, TabItemTemplate},
  props: {
    serviceProfileId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      processProfileView: [],
      serviceProfile: {},
      processOperationOperationTypes: PROCESS_OPERATION_OPERATION_TYPES,
    };
  },
  computed: {
    ...mapGetters({
      hcsClient: 'hcs/client',
      hdsEntities: 'hds/entities',
    }),
    isConsumeServiceType() {
      return ['common', 'consume'].includes(this.serviceProfile.serviceType);
    },
    isProduceServiceType() {
      return ['common', 'produce'].includes(this.serviceProfile.serviceType);
    }
  },
  methods: {
    ...mapActions({
      loadProcessProfiles: 'hcs/processProfile/findList',
      loadProcessImplementations: 'hcs/processImplementation/findList',
      loadProcessOperationImplementations: 'hcs/processOperationImplementation/findList',
      gqlQuery: 'hds/gqlQuery',
    }),
  },
  watch: {
    serviceProfileId: {
      immediate: true,
      async handler(serviceProfileId) {
        const {data: serviceProfile} = await this.hcsClient.get(`/service_profiles/${serviceProfileId}`);
        const processOperationImplementations = await this.loadProcessOperationImplementations();
        const processImplementations = await this.loadProcessImplementations();
        const processProfiles = (await this.loadProcessProfiles())
            .filter(pp => pp.serviceProfileId === serviceProfileId)
            .map(pp => ({
              ...pp,
              processImplementation: processImplementations.find(pi => pi.id === pp.processImplementationId)
            }));

        const {processComponentModels} = await this.gqlQuery({
          query: gql`
            query FindProcessComponentModel(
                $processComponentModelIds: [ID!]!,
            ) {
                processComponentModels: processComponentModelInBulk(processComponentModelIds: $processComponentModelIds) {
                    id
                    name
                    description
                }
            }`,
          variables: {
            processComponentModelIds: uniq(processProfiles.map(pp => pp.processImplementation.processComponentModelId))
          }
        });

        this.serviceProfile = serviceProfile;
        this.processProfileView = processProfiles.map(pp => {
          const pi = pp.processImplementation;
          const pcm =  processComponentModels.find(pcm => pcm.id === pi.processComponentModelId);
          return {
            ...pp,
            name: pcm?.name,
            description: pcm?.description,
            create: !!processOperationImplementations.find(poi => poi.processImplementationId === pi.id && poi.operationType === 'create'),
            read: !!processOperationImplementations.find(poi => poi.processImplementationId === pi.id && poi.operationType === 'read'),
            update: !!processOperationImplementations.find(poi => poi.processImplementationId === pi.id && poi.operationType === 'update'),
            delete: !!processOperationImplementations.find(poi => poi.processImplementationId === pi.id && poi.operationType === 'delete'),
          };
        });
      }
    }
  }
}
</script>

<style scoped>

</style>
